import React from 'react';
import PropTypes from 'prop-types';
import { DropdownLight } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function CurrencySelector({ value, onChange, disabled = false, ...rest }) {
    const { t } = useTranslation();

    const currencies = React.useMemo(() => {
        return [
            { value: 'EUR', label: t('currencies.label.eur') },
            { value: 'CHF', label: t('currencies.label.chf') },
            { value: 'GBP', label: t('currencies.label.gbp') },
            { value: 'CAD', label: t('currencies.label.cad') },
            { value: 'USD', label: t('currencies.label.usd') },
            { value: 'ZAR', label: t('currencies.label.zar') }
        ];
    }, [t]);

    return <DropdownLight value={value} onChange={onChange} items={currencies} disabled={disabled} {...rest} />;
}

CurrencySelector.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};
